// src/components/QuickLinksSection.jsx
import React from 'react';
import { Container, Box } from '@mui/material';
import QuickLinkCard from './QuickLinkCard';

import exhibitImg     from '../../assets/homePage/exhibit1.jpg';
import tourImg        from '../../assets/homePage/tour1.JPG';
import eventsImg      from '../../assets/homePage/events1.jpg';
import membershipImg  from '../../assets/homePage/membership1.PNG';
import archiveImg     from '../../assets/homePage/archive1.jpg';

import MuseumIcon     from '@mui/icons-material/Museum';
import TrainIcon      from '@mui/icons-material/Train';
import EventIcon      from '@mui/icons-material/Event';
import GroupAddIcon   from '@mui/icons-material/GroupAdd';
import ArchiveIcon    from '@mui/icons-material/Archive';

export default function QuickLinksSection() {
    const cards = [
        {
            title: 'Exhibits',
            description: 'Explore our different walk through and interactive exhibits in the different rooms of the depot.',
            icon: MuseumIcon,
            href: '/exhibits',
            image: exhibitImg,
        },
        {
            title: 'Plan a Visit',
            description: 'Take a tour through the restored depot to learn about Piedmont and Alabama history.',
            icon: TrainIcon,
            href: '/visit',
            image: tourImg,
        },
        {
            title: 'Events',
            description: 'Check out our calendar of upcoming historical events and previous events!',
            icon: EventIcon,
            href: '/events',
            image: eventsImg,
        },
        {
            title: 'Membership',
            description: 'Join the Piedmont Historical Society and connect with our community of fellow history lovers.',
            icon: GroupAddIcon,
            href: '/membership',
            image: membershipImg,
        },
        {
            title: 'Archives',
            description: 'Access our vault of historical photos, maps, letters, and records to discover Piedmont\'s story.',
            icon: ArchiveIcon,
            href: '/archives',
            image: archiveImg,
        },
    ];

    return (
        <Box sx={{ backgroundColor: 'common.white', pt: 0, pb: 8 }}>
            <Container maxWidth="lg">
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                        gap: 4,
                    }}
                >
                    {cards.map((card) => (
                        <QuickLinkCard key={card.title} {...card} />
                    ))}
                </Box>
            </Container>
        </Box>
    );
}
